import { Divider } from '@mui/material';
import { Box } from '@mui/system';
import { LayoutItem } from 'api/models';

interface DividerFieldProps {
  layoutItem: LayoutItem;
}

export function DividerField({ layoutItem }: DividerFieldProps) {
  return (
    <Box width="100%">
      {layoutItem?.subType === 'header' ? (
        <div
          style={{
            marginBottom: '10px',
          }}
          dangerouslySetInnerHTML={{
            __html: layoutItem?.label ?? '',
          }}
        />
      ) : (
        <Divider sx={{ mb: 2, width: '100%' }} />
      )}
    </Box>
  );
}
